import type { RouteObject } from "react-router";

/**
 * Both public, with no loader: a customer reads the menu and picks a time before they have an
 * account, and the booking flow offers sign-in in place at the confirm step (design note section 2).
 *
 * Loaded on demand, so the salon's home page paints without the booking flow's code
 * (TDD-SA NFR-SA-009, Phase 6 design D5). The home page links here; the chunk arrives on the tap.
 */
export const bookingRoutes: RouteObject[] = [
  { path: "services", lazy: async () => ({ Component: (await import("./pages/ServicesPage")).ServicesPage }) },
  { path: "book", lazy: async () => ({ Component: (await import("./pages/BookPage")).BookPage }) },
];
